import { render, staticRenderFns } from "./BuckClouds.vue?vue&type=template&id=05ff2d0c&"
import script from "./BuckClouds.vue?vue&type=script&lang=ts&"
export * from "./BuckClouds.vue?vue&type=script&lang=ts&"
import style0 from "./BuckClouds.vue?vue&type=style&index=0&id=05ff2d0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports